import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Segment} from '../../segment.model';
import { Observable } from 'rxjs';
import {SegmentAuditLog} from '../../../audit-logs/audit-logs.service';
import {AuditLogsFacadeService} from '../../../audit-logs/audit-logs-facade.service';

@Component({
  selector: 'app-segment-audit-logs',
  template: `
    <app-audit-log *ngFor="let segmentAuditLog of (segmentAuditLogs | async)" [auditLog]="segmentAuditLog"></app-audit-log>
  `,
  styleUrls: ['./segment-audit-logs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SegmentAuditLogsComponent implements OnInit {
  selectedSegment?: Segment;
  segmentAuditLogs?: Observable<SegmentAuditLog[]> = this.segmentAuditLogFacadeService.selectSegmentAuditLogs();
  constructor(private segmentAuditLogFacadeService: AuditLogsFacadeService) { }

  ngOnInit(): void {
    this.segmentAuditLogFacadeService.loadSegmentAuditLogs();
  }

}
